const reviews = [
	{
		path: '/community/contents/reviews/list',
		name: 'community-contents-reviews-list',
		component: () => import('@/views/community/reviews/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/contents/reviews/new',
		name: 'community-contents-reviews-create',
		component: () => import('@/views/community/reviews/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/contents/reviews/edit/:slug',
		name: 'community-contents-reviews-edit',
		component: () => import('@/views/community/reviews/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/contents/reviews/ai/create',
		name: 'community-contents-reviews-ai-create',
		component: () => import('@/views/community/reviews/ai-create.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/contents/reviews/ai/jobs',
		name: 'community-contents-reviews-ai-jobs',
		component: () => import('@/views/community/reviews/ai-jobs-list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
	{
		path: '/community/contents/reviews/ai/jobs/:uuid',
		name: 'community-contents-reviews-ai-job-detail',
		component: () => import('@/views/community/reviews/ai-job-detail.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,contents',
		},
	},
]

export default reviews
